export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  author: string;
  readTime: string;
  content: string;
  tags: string[];
  featured?: boolean;
}

export const articles: Article[] = [
  {
    slug: "bailu-2025-chunji-xiezhen",
    title: "白露2025春季写真：花开时节的自然之美",
    excerpt: "白露最新春季写真作品，在花海之中展现清新自然的独特气质。柔和的光线与细腻的表情捕捉，呈现出令人心动的画面质感。",
    category: "qingxin-xiezhen",
    image: "https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20model%20in%20spring%20flower%20field%2C%20natural%20soft%20lighting%2C%20fresh%20elegant%20portrait%20photography%2C%20white%20dress%2C%20cherry%20blossom%20background%2C%20dreamy%20atmosphere%2C%20professional%20fashion%20photography%2C%20clean%20composition&width=800&height=600&seq=article-spring-2025&orientation=landscape",
    date: "2025-03-15",
    author: "张明远",
    readTime: "8分钟",
    featured: true,
    content: "",
    tags: ["春季写真", "清新风格", "户外拍摄"],
  },
  {
    slug: "bailu-heibai-xiezhen-jingxuan",
    title: "白露黑白写真精选：光影之间的永恒瞬间",
    excerpt: "精选白露近年最受欢迎的黑白写真作品，去掉色彩的干扰，让光影与情绪成为画面的绝对主角。",
    category: "heibai-jingdian",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20black%20and%20white%20portrait%20photography%2C%20dramatic%20lighting%20shadows%2C%20artistic%20elegant%20pose%2C%20minimalist%20studio%20background%2C%20high%20contrast%20monochrome%2C%20professional%20fine%20art%20photography&width=800&height=600&seq=article-bw-2025&orientation=landscape",
    date: "2025-02-20",
    author: "李明",
    readTime: "10分钟",
    featured: true,
    content: "",
    tags: ["黑白摄影", "经典风格", "光影艺术"],
  },
  {
    slug: "gudian-meiren-hanfu-xiezhen",
    title: "古典美人：白露汉服写真惊艳亮相",
    excerpt: "白露身穿精美汉服，在古典园林中演绎东方美人的婉约与典雅。每一帧都如画般精致。",
    category: "gudian-meiren",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20wearing%20traditional%20hanfu%20costume%20in%20classical%20garden%2C%20elegant%20Eastern%20beauty%2C%20traditional%20Chinese%20architecture%20background%2C%20soft%20natural%20lighting%2C%20professional%20portrait%20photography%2C%20serene%20atmosphere&width=800&height=600&seq=article-hanfu-2025&orientation=landscape",
    date: "2025-01-10",
    author: "王芳",
    readTime: "12分钟",
    featured: true,
    content: "",
    tags: ["汉服写真", "古典风格", "东方美学"],
  },
  {
    slug: "shishang-dapian-2025-winter",
    title: "白露2025冬季时尚大片：冷艳与高级感的碰撞",
    excerpt: "知名时尚摄影师操刀，白露在冬季都市背景下演绎高级时装，展现成熟冷艳的一面。",
    category: "shishang-dapian",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20fashion%20model%20in%20winter%20urban%20street%2C%20luxury%20coat%2C%20cold%20elegant%20expression%2C%20professional%20fashion%20editorial%20photography%2C%20city%20background%2C%20high%20end%20magazine%20style%2C%20clean%20composition&width=800&height=600&seq=article-fashion-2025&orientation=landscape",
    date: "2024-12-25",
    author: "张明远",
    readTime: "9分钟",
    content: "",
    tags: ["时尚大片", "冬季拍摄", "高级时装"],
  },
  {
    slug: "shinei-xiezhen-buguang-jiqiao",
    title: "室内写真拍摄技巧：如何利用自然光打造高级感人像",
    excerpt: "以白露室内写真作品为例，详细解析如何利用窗边自然光配合简单补光设备，打造质感出众的人像作品。",
    category: "paishe-jiqiao",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20indoor%20portrait%20photography%20near%20window%2C%20natural%20light%20soft%20shadows%2C%20minimalist%20white%20room%2C%20professional%20photography%20setup%2C%20warm%20atmosphere%2C%20elegant%20pose%2C%20clean%20composition&width=800&height=600&seq=article-indoor-tips&orientation=landscape",
    date: "2024-11-18",
    author: "陈思远",
    readTime: "15分钟",
    content: "",
    tags: ["拍摄技巧", "室内写真", "布光教程"],
  },
  {
    slug: "bailu-zhive-fazhan-zhiu",
    title: "白露的职业发展之路：从新人到知名模特的蜕变",
    excerpt: "回顾白露从入行到成为国内知名模特的成长历程，分享舞台背后的坚持与努力。",
    category: "moshi-gushi",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20behind%20the%20scenes%20professional%20photoshoot%2C%20makeup%20and%20styling%20preparation%2C%20studio%20environment%2C%20warm%20lighting%2C%20documentary%20style%20photography%2C%20professional%20atmosphere&width=800&height=600&seq=article-career-2025&orientation=landscape",
    date: "2024-10-08",
    author: "李婷",
    readTime: "18分钟",
    content: "",
    tags: ["模特故事", "职业发展", "行业经验"],
  },
  {
    slug: "huwai-renshen-jinqiu-xiezhen",
    title: "金秋户外人像：白露秋日写真拍摄全记录",
    excerpt: "深秋时节，白露在金黄色的银杏林和芦苇丛中完成了一组绝美的户外人像拍摄。一起走进拍摄现场。",
    category: "huwai-renshen",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20outdoor%20autumn%20portrait%2C%20golden%20ginkgo%20leaves%20background%2C%20warm%20sunset%20lighting%2C%20natural%20elegant%20pose%2C%20professional%20portrait%20photography%2C%20beautiful%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=article-autumn-2025&orientation=landscape",
    date: "2024-09-22",
    author: "王浩然",
    readTime: "11分钟",
    content: "",
    tags: ["户外人像", "秋季写真", "自然光拍摄"],
  },
  {
    slug: "renxiang-goutu-sheying-jichu",
    title: "人像摄影构图基础：让白露的作品告诉你什么是最好的构图",
    excerpt: "通过分析白露多组写真作品中的构图技巧，深入浅出地讲解三分法、引导线、框架构图等实用知识。",
    category: "paishe-jiqiao",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20composition%20examples%2C%20Chinese%20female%20model%2C%20rule%20of%20thirds%20demonstration%2C%20leading%20lines%20technique%2C%20clean%20studio%20background%2C%20educational%20photography%20guide%2C%20elegant%20pose&width=800&height=600&seq=article-composition-2025&orientation=landscape",
    date: "2024-08-15",
    author: "陈思远",
    readTime: "14分钟",
    content: "",
    tags: ["拍摄技巧", "构图教程", "摄影基础"],
  },
  {
    slug: "bailu-qipaio-xiezhen-jingxuan",
    title: "白露旗袍写真精选：东方女性的温婉与优雅",
    excerpt: "身穿各式旗袍的白露，在传统与现代之间自由切换，展现出中国女性独特的温婉魅力。",
    category: "gudian-meiren",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20wearing%20elegant%20qipao%20cheongsam%2C%20classical%20Shanghai%20style%2C%20vintage%20room%20background%2C%20soft%20warm%20lighting%2C%20graceful%20feminine%20pose%2C%20professional%20portrait%20photography%2C%20clean%20composition&width=800&height=600&seq=article-qipao-2025&orientation=landscape",
    date: "2024-07-20",
    author: "王芳",
    readTime: "10分钟",
    content: "",
    tags: ["旗袍写真", "东方美学", "古典风格"],
  },
  {
    slug: "shouji-renshen-paishe-jiqiao",
    title: "手机人像也能出大片：白露示范的手机拍摄技巧",
    excerpt: "即使没有专业设备，掌握这些技巧也能用手机拍出好看的人像照片。白露亲身示范讲解。",
    category: "paishe-jiqiao",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20demonstrating%20mobile%20phone%20photography%2C%20casual%20lifestyle%20setting%2C%20bright%20natural%20lighting%2C%20modern%20minimalist%20interior%2C%20professional%20yet%20approachable%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=article-mobile-2025&orientation=landscape",
    date: "2024-06-12",
    author: "陈思远",
    readTime: "12分钟",
    content: "",
    tags: ["拍摄技巧", "手机摄影", "入门教程"],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getRecentArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, count);
}